class CookieConsent {
    static STORAGE_KEY = "cookie-consent-v1";
    static CHANGE_EVENT = "cookie-consent-change";

    static read() {
        try {
            return JSON.parse(localStorage.getItem(CookieConsent.STORAGE_KEY)) || {};
        } catch (e) {
            return {};
        }
    }

    static save(values) {
        localStorage.setItem(CookieConsent.STORAGE_KEY, JSON.stringify(values));
        window.dispatchEvent(new CustomEvent(CookieConsent.CHANGE_EVENT, {detail: values}));
    }

    static hasMarketingConsent() {
        return CookieConsent.read().marketing === true;
    }

    // Zwraca funkcję wyrejestrowującą — do użycia jako cleanup w useEffect.
    static onChange(listener) {
        window.addEventListener(CookieConsent.CHANGE_EVENT, listener);

        return () => window.removeEventListener(CookieConsent.CHANGE_EVENT, listener);
    }
}

export default CookieConsent;
